import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=f6d62b2e&scoped=true&"
import script from "./Config.vue?vue&type=script&lang=ts&"
export * from "./Config.vue?vue&type=script&lang=ts&"
import style0 from "./Config.vue?vue&type=style&index=0&id=f6d62b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d62b2e",
  null
  
)

export default component.exports